//* Vue
import type { SetupContext } from "vue";

//* 二维码
import qrcode_wechat from "@/assets/images/common/wechat-code-a2bc7564-948a-4e92-8928-745f181521ef.webp";
import qrcode_bilibil from "@/assets/images/common/bilibili-code-bd341270-f4b4-45ea-a222-0c6601106497.webp";

type MediaData = { key: string; name: string; copy: string; label: string; qrcode?: string };

export const useComposable = (define: { top?: number; isTop: boolean }, emits: SetupContext<["returnTop"]>["emit"]) => {
    //* 插件
    const i18n = useI18n();

    //* 静态数据
    const vars = {
        insides: [
            { link: { name: "Tool" }, name: i18n.t("Toolbox") },
            { link: { name: "About" }, name: i18n.t("AboutTheSite") },
            { link: { name: "ContactUs" }, name: i18n.t("ContactUS") },
        ],

        blogrolls: [
            { link: "http://www.tsinghua-gd.org/", name: i18n.t("TsinghuaName") },
            { link: i18n.locale.value == "zh" ? "https://www.cyagen.cn/" : "https://www.cyagen.com/us/en/", name: i18n.t("CyagenName") },
            { link: "https://www.zssy.com.cn/", name: i18n.t("SunYatSenName") },
        ],
        medias: <MediaData[]>[
            {
                key: "wechat",
                name: i18n.t("ContactUSWeChat"),
                copy: "rddc-support",
                label: i18n.t("Wechat"),
                qrcode: qrcode_wechat,
            },
            {
                key: "bilibili",
                name: i18n.t("ContactUSBilibili"),
                copy: "https://space.bilibili.com/1553929661",
                label: i18n.t("Link"),
                qrcode: qrcode_bilibil,
            },
            {
                key: "linkedin",
                name: i18n.t("ContactUSLinkedIn"),
                copy: "https://www.linkedin.com/company/cyagen-biosciences",
                label: i18n.t("Link"),
            },
            {
                key: "youtube",
                name: i18n.t("ContactUSYouTube"),
                copy: "https://www.youtube.com/@Cyagen",
                label: i18n.t("Link"),
            },
        ],
    };

    //* 函数列表
    const methods = {
        return: () => {
            if (define.isTop) emits("returnTop");
            else {
                window.scrollTo({ top: 0, behavior: "smooth" });
            }
        },

        next: (response: MediaData) => {
            if (response.key != "wechat") open(response.copy, "_blank");
        },
    };

    //* 计算属性
    const computeds = {
        styles: computed(() => {
            if (typeof define.top == "number" && define.top >= 0) return { marginTop: define.top + "px" };
            else {
                return {};
            }
        }),
    };

    return { vars, methods, computeds };
};
